import './style.scss';

import { Button as AntButton, ButtonProps } from 'antd';
import React from 'react';

export interface IButtonProps extends ButtonProps {
  className?: string;
  text?: string;
  action?: any;
  loading?: boolean;
  disabled?: boolean;
  display?: boolean;
}

export const Button: React.FC<IButtonProps> = ({
  action,
  text,
  className,
  display = true,
  ...otherProps
}: IButtonProps) =>
  display ? (
    <AntButton onClick={action} {...otherProps} className={`btn ${className}`}>
      {text}
    </AntButton>
  ) : null;
